import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/AI.png';
import _imports_1 from '../../assets/refresh.png';
import _imports_2 from '../../assets/closes.png';
import _imports_3 from '../../assets/time.png';
import _imports_4 from '../../assets/copy.png';
import _imports_5 from '../../assets/aiuser.png';
import _imports_6 from '../../assets/user1.png';
import _imports_7 from '../../assets/stop.png';
import _imports_8 from '../../assets/send.png';
const _withScopeId = n => (_pushScopeId("data-v-13b67f48"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top_t_box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "_icon_boxs"
}, [/*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_0,
  alt: ""
}), /*#__PURE__*/_createElementVNode("span", {
  class: "text_1icon"
}, "智能助手 ")], -1));
const _hoisted_3 = {
  class: "_right_boxs"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "_refreshs_img",
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text_2"
}, "更新聊天记录", -1));
const _hoisted_6 = [_hoisted_4, _hoisted_5];
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "imgs",
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_8 = [_hoisted_7];
const _hoisted_9 = {
  class: "cont_boxs"
};
const _hoisted_10 = ["item", "index"];
const _hoisted_11 = {
  key: 0,
  class: "_right_box"
};
const _hoisted_12 = {
  class: "conts flex-end"
};
const _hoisted_13 = {
  class: "text_ops color_2 _right_cont"
};
const _hoisted_14 = ["innerHTML"];
const _hoisted_15 = {
  class: "times"
};
const _hoisted_16 = {
  class: "_timk"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_18 = {
  class: "t_title1 t_title1_color"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "t_title1 t_title1_color"
}, "复制", -1));
const _hoisted_22 = [_hoisted_20, _hoisted_21];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_aru",
  src: _imports_5,
  alt: ""
}, null, -1));
const _hoisted_24 = {
  key: 1,
  class: "_left_box"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon_aru",
  src: _imports_6,
  alt: ""
}, null, -1));
const _hoisted_26 = {
  class: "conts"
};
const _hoisted_27 = {
  class: "text_ops color_1 _left_cont"
};
const _hoisted_28 = {
  key: 0,
  class: "laoding_boxs"
};
const _hoisted_29 = {
  class: "times2"
};
const _hoisted_30 = {
  class: "_timk"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_32 = {
  class: "t_title1 t_title1_color"
};
const _hoisted_33 = ["onClick"];
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "t_title1 t_title1_color"
}, "复制", -1));
const _hoisted_36 = [_hoisted_34, _hoisted_35];
const _hoisted_37 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icons",
  src: _imports_7,
  alt: ""
}, null, -1));
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "t_title1 t_title1_color"
}, "停止", -1));
const _hoisted_39 = [_hoisted_37, _hoisted_38];
const _hoisted_40 = {
  class: "cont_tag"
};
const _hoisted_41 = {
  class: "border_tag"
};
const _hoisted_42 = ["onClick"];
const _hoisted_43 = {
  class: "message"
};
const _hoisted_44 = {
  class: "message-box"
};
const _hoisted_45 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "lisp"
}, "Enter发送/Shift+Enter换行", -1));
const _hoisted_46 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "send_icon",
  src: _imports_8,
  alt: ""
}, null, -1));
const _hoisted_47 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "send_text"
}, "发送", -1));
const _hoisted_48 = [_hoisted_46, _hoisted_47];
import Loading from "@/components/loading/index.vue";
import { ref, nextTick } from "vue";
import { ElMessage } from "element-plus";
import { getlast_id, create_session, getchat_history, getprompt_list } from "@/service/modules/alllist";
import baseURL from "@/config/base-url";
import { fetchEventSource } from "@microsoft/fetch-event-source";
const mark = '当然，这是一个简单的Hive SQL查询示例，用于从名为"tabl eName"的表中选择所有的记录：\n\n```sql\nSELECT * FROM tableName;\n```\n\n这个语句将返回"tabl eName"表中的所有字段和对应的数据。';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    md5: String,
    from: String
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const message = ref("");
    const lits_Chat = ref([]);
    const vmdpreview = ref();
    const loading = ref(false);
    const isQuestionAsked = ref(false);
    const send = () => {
      if (message.value.trim()) {
        // 获取当前时间
        const currentTime = new Date().toLocaleString();
        // 将用户的消息添加到聊天列表
        lits_Chat.value.push({
          user_text: message.value,
          ai_text: "",
          up_time: currentTime,
          loading: true
        });
        // 确保每次发消息后滚动到底部
        scrollToBottom();
        setupEventSourcePost();
        // 设置问题已被问
        // 清空输入框
        message.value = "";
      }
    };
    const ctrlAbout = new AbortController();
    // const setupEventSource = () => {
    //   const eventSource = new EventSource(`${baseURL}/api/ai/completions`);
    //   eventSource.onmessage = (event) => {
    //     console.log("New message:", event.data);
    //     // messages.value.push(event.data);
    //   };
    //   eventSource.onerror = (error) => {
    //     console.error("EventSource failed:", error);
    //     // eventSource.close();
    //   };
    //   return eventSource;
    // };
    const scrollToBottom = () => {
      nextTick(() => {
        const container = document.querySelector(".cont");
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      });
    };
    const setupEventSourcePost = () => {
      const url = `${baseURL}/api/ai_chat/completions`;
      // 开始请求时，设置 loading 为 true
      loading.value = true;
      fetchEventSource(url, {
        method: "POST",
        headers: {
          Accept: "text/event-stream",
          "Content-Type": "application/json"
        },
        openWhenHidden: true,
        signal: ctrlAbout.signal,
        body: JSON.stringify({
          session_id: chat_md5.value,
          text: message.value,
          chat_md5: props.md5,
          userid: props.from
        }),
        onmessage(event) {
          try {
            const parsedData = JSON.parse(event.data);
            const resultText = parsedData.result.replace(/\n/g, "<br>");
            // 找到最后一条正在处理的消息
            const lastMessage = lits_Chat.value.find(item => item.loading);
            // 更新 AI 回复
            if (lastMessage) {
              lastMessage.ai_text += resultText;
              // 确保每次接收到 AI 消息后滚动到底部
              scrollToBottom();
            }
            // // 更新 AI 回复
            // if (lits_Chat.value.length > 0) {
            //   lits_Chat.value[lits_Chat.value.length - 1].ai_text += resultText;
            //   // 确保每次接收到 AI 消息后滚动到底部
            //   scrollToBottom();
            // } else {
            //   console.error("没有可更新的聊天项。");
            // }
          } catch (error) {
            console.error("Failed to parse message data:", error);
          }
        },
        onerror(error) {
          console.error("Service error:", error);
          // 找到最后一条正在处理的消息并将其 loading 状态设为 false
          const lastMessage = lits_Chat.value.find(item => item.loading);
          if (lastMessage) {
            lastMessage.loading = false;
          }
        },
        onclose() {
          // 找到最后一条正在处理的消息并将其 loading 状态设为 false
          const lastMessage = lits_Chat.value.find(item => item.loading);
          if (lastMessage) {
            lastMessage.loading = false;
          }
          console.log("Service closed");
        }
      });
    };
    const stop_event = () => {
      // 终止流请求
      ctrlAbout.abort();
    };
    const sendShiftEnter = event => {
      if (event.shiftKey) {
        message.value += "\n";
      } else {
        send();
      }
    };
    const closeDialog = () => {
      emit("closeDialog");
    };
    const chat_md5 = ref("");
    const getSession_id = async () => {
      let res = await getlast_id(props.md5);
      console.log(res, "----没有历史会话 id");
      if (!res.data) {
        let reqdata = {
          chat_md5: props.md5
        };
        let res2 = await create_session(reqdata);
        console.log(res2, "----获取新的会话id");
        chat_md5.value = res2.data;
      } else {
        chat_md5.value = res.data;
      }
    };
    const active_tag = ref("");
    const tag_list = ref([]);
    const get_tag_list = async () => {
      let res = await getprompt_list({
        page: 1
      });
      tag_list.value = res.data.data;
    };
    const copys = item => {
      let oInput = document.createElement("input");
      oInput.value = item;
      document.body.appendChild(oInput);
      oInput.select();
      console.log(oInput.value);
      document.execCommand("Copy");
      oInput.remove();
      ElMessage.success("复制成功");
    };
    const get_tag_ = (item, index) => {
      active_tag.value = index;
      message.value = item;
      send();
    };
    const page = ref(1);
    const totalMessages = ref(0);
    const showLoadMore = ref(false);
    const container = ref(null); // 用 ref 来获取 DOM
    const handleScroll = () => {
      const container = document.querySelector(".cont");
      if (container && container.scrollTop === 0 && totalMessages.value > lits_Chat.value.length) {
        showLoadMore.value = true;
      }
    };
    const loadMore = async () => {
      showLoadMore.value = false;
      const oldScrollHeight = container.value.scrollHeight;
      page.value += 1;
      await fetchMoreMessages();
      await nextTick(); // 确保 DOM 更新后再操作
      // Update scroll position to keep the current view
      const newScrollHeight = container.value.scrollHeight;
      container.value.scrollTop = newScrollHeight - oldScrollHeight;
    };
    const fetchMoreMessages = async () => {
      // 获取下一页的消息，这里根据您的接口调整请求
      let res = await getchat_history(`${chat_md5.value}?page=${page.value}`);
      if (res.code == 0) {
        const newMessages = res.data.data.reverse();
        lits_Chat.value = newMessages.concat(lits_Chat.value);
        totalMessages.value = res.data.total;
      }
    };
    const get_list = async () => {
      let reqdata = `${chat_md5.value}?page=${page.value}`;
      let res = await getchat_history(reqdata);
      if (res.code == 0) {
        lits_Chat.value = res.data.data.reverse();
        totalMessages.value = res.data.total;
        scrollToBottom();
      }
    };
    const set_new = async () => {
      let reqdata = {
        chat_md5: props.md5
      };
      let res = await create_session(reqdata);
      if (res.data) {
        chat_md5.value = res.data;
        lits_Chat.value = [];
        page.value = 1;
        totalMessages.value = 0;
        // get_list();
      }
    };

    const get_items = item => {
      // return item.replace(/\n/g, "<br>");
      return item || "";
    };
    //固定一下提交参数， md5  245b167fc58f8db44a7a4784f445859d    会话 id    session_id :chat_md5.value  userid: 员工 from
    const get_init = async () => {
      await getSession_id();
      await get_list();
      await get_tag_list();
    };
    get_init();
    return (_ctx, _cache) => {
      const _component_v_md_preview = _resolveComponent("v-md-preview");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        width: "800",
        top: "3vh",
        draggable: true,
        overflow: "",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog,
        class: "ai_dialog"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
          class: "_refreshs",
          onClick: _cache[0] || (_cache[0] = $event => set_new())
        }, _hoisted_6), _createElementVNode("div", {
          class: "closesa",
          onClick: closeDialog
        }, _hoisted_8)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", {
          class: "cont",
          onScroll: handleScroll,
          ref_key: "container",
          ref: container
        }, [showLoadMore.value ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "load-more",
          onClick: loadMore
        }, " 加载更多 ")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lits_Chat.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item_boxs",
            item: item,
            index: index,
            key: index
          }, [item.user_text ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", {
            innerHTML: get_items(item.user_text)
          }, null, 8, _hoisted_14)]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(item.up_time), 1)]), _createElementVNode("div", {
            class: "rights_copy",
            onClick: $event => copys(get_items(item.user_text))
          }, _hoisted_22, 8, _hoisted_19)])]), _hoisted_23])) : _createCommentVNode("", true), item.ai_text || item.loading ? (_openBlock(), _createElementBlock("div", _hoisted_24, [_hoisted_25, _createElementVNode("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_createVNode(_component_v_md_preview, {
            ref_for: true,
            ref_key: "vmdpreview",
            ref: vmdpreview,
            text: get_items(item.ai_text)
          }, null, 8, ["text"]), item.loading ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(Loading, {
            loading: true
          })])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("span", _hoisted_32, _toDisplayString(item.up_time), 1)]), _createElementVNode("div", {
            class: "rights_copy",
            onClick: $event => copys(get_items(item.ai_text))
          }, _hoisted_36, 8, _hoisted_33), _createElementVNode("div", {
            class: "rights_copy",
            onClick: _cache[1] || (_cache[1] = $event => stop_event())
          }, _hoisted_39)])])])) : _createCommentVNode("", true)], 8, _hoisted_10);
        }), 128))], 544)]), _createElementVNode("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tag_list.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["tag_s", active_tag.value == index ? 'a-actives' : 'no-actives']),
            onClick: $event => get_tag_(item.prompt, index),
            key: index
          }, _toDisplayString(item.name), 11, _hoisted_42);
        }), 128))])]), _createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, [_createVNode(_component_el_input, {
          class: "input_ops",
          type: "textarea",
          modelValue: message.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => message.value = $event),
          placeholder: "请输入",
          onKeydown: [_withKeys(_withModifiers(send, ["exact"]), ["enter"]), _withKeys(_withModifiers(sendShiftEnter, ["prevent"]), ["enter", "native", "modifiers"])]
        }, null, 8, ["modelValue", "onKeydown"]), _createElementVNode("div", {
          class: "footer"
        }, [_hoisted_45, _createElementVNode("div", {
          class: "btn_send",
          onClick: send
        }, _hoisted_48)])])])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
});